import React from 'react';

function CategoryNameComponent({ category, content, className, suffix, showId, ...props }) {

	const suffixDisplay = suffix ? <span>{' '}{suffix}</span> : null
	const idDisplay = showId ? <span>{' '}{category.id}</span> : null

	return (
		<span
			className={`${className ?? 'category_name_inner'} category_name_text `}
			title={category.name}
			style={{ color: category.getColor() }}
			{...props}
		>
			{content ? content : category.name}{idDisplay}{suffixDisplay}
		</span>
	);
}

/**
 * Whether this can skip a re-render.
 *
 * `color` has to be in here even though nothing in the markup reads it directly, because
 * `getColor()` does. It arrives from the server after the first paint, and categories are mutated
 * in place -- `CacheableDataObject.update()` writes onto the instance the component already holds,
 * so the name is unchanged and every other comparison here says "equal". Leave colour out and the
 * first render is the only one: every category stays the neutral grey it was drawn with before its
 * colour had loaded. That was invisible while `getColor()` derived from `id`, which is set at
 * construction and could never arrive late.
 */
export function isEqual(prevProps, nextProps) {
	return prevProps.category.name === nextProps.category.name
		&& prevProps.category.color === nextProps.category.color
		&& prevProps.className === nextProps.className
		&& prevProps.suffix === nextProps.suffix
		&& prevProps.content === nextProps.content;
}

export default React.memo(CategoryNameComponent, isEqual);
